module.exports = "/images/slide-qs-t-9.jpg";